import { AxiosError, AxiosResponse } from "axios";
import protheusProvider from "../providers/protheus.provider";

export class ScheduleService {
  public async index(token: string | null, month: number, year: number, period: boolean, analista?: string): Promise<AxiosResponse> {
    const params: any = {
      token, 
      month,
      year,
      period, 
    }

    if(analista) { params.analista = analista }

    try {
      const response = await protheusProvider.get('WSRESTAGENDA', { params } );
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async getReceiveValue(token: string | null, month: number, year: number): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTFINANC', {
        params: {
          token, 
          month,
          year,
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}